export default function (monitoringPercent) {
  if (isNaN(parseFloat(monitoringPercent)) || !isFinite(monitoringPercent)) {
    return '-'
  } else {
    return `${(Math.round(monitoringPercent * 100) / 100)}%`
  }
}
